<app-access-item [hideOverflow]="true" (click)="customize.emit()">
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/color-bucket.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <span>Colors</span>
  </app-access-item-header>
  <app-access-item-cta>
    <button
      appButton
      name="customize"
      location="theme-colors-item"
      [iconButton]="true"
      color="simple-gray-50"
      height="0"
    >
      <app-svg src="/assets/icons/arrow-right.svg" size="0"></app-svg>
    </button>
  </app-access-item-cta>
</app-access-item>
